import { validationLength } from "../components/actions/validations";

const codeMax = validationLength.roleCode;
const nameMax = validationLength.roleName;

const codeRule = (max: number) =>
  `Max ${max} characters; letters and numbers only; no spaces or special characters.`;

const spaceRule = (max: number) =>
  `Max ${max} characters; letters, numbers and spaces only; no special characters.`;

/** Default (non-error) helper text under Reserve Roles fields. */
export const reserveRolesFieldHelperText = {
  roleCode: `${codeRule(codeMax)} Mandatory.`,
  roleName: `${spaceRule(nameMax)} Mandatory.`,
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveRolesFieldErrors = {
  required: "This field is required.",
  roleCode: codeRule(codeMax),
  roleName: spaceRule(nameMax),
} as const;
